
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trails/[slug]",
      function () {
        return require("private-next-pages/trails/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trails/[slug]"])
      });
    }
  